import React from 'react';
import {Grid, Row, Col} from 'react-bootstrap'
import openCallout from '../../../../resources/images/open-callout.png'
import closeCallout from '../../../../resources/images/close-callout.png'
import trash from '../../../../resources/images/trash-green.png'
import _ from 'lodash'
import {userIsGroupAdmin} from '../../../constants'

const GroupView = (props) => {

    //console.log('GroupView', props)

    if (props.selected) {
        return <Row className="group-row">

            <div>
                <Grid fluid>
                    <Row className="group-row-open" onClick={() => props.closeGroup(props.group)}>
                        <Col xs={10} className="group-name-open">{props.group.name}</Col>
                        <Col xs={2} className="group-row-closed-callout">
                            <button className="link">
                                <img src={closeCallout} alt="close" />
                            </button>
                        </Col>
                    </Row>
                </Grid>
            </div>

            <div className="group-details">
                <Grid fluid>
                    <Row className="table-title">
                        <Col xs={12} sm={3} md={3}>GROUP MEMBERS</Col>
                        <Col xsHidden sm={3} md={3}>PHONE</Col>
                        <Col xsHidden sm={3} md={3}>EMAIL</Col>
                        <Col xsHidden sm={3} md={3}/>
                    </Row>

                    {(props.users || []).map(u => <Row className="group-info" key={`${props.group.id}_${u.id}_${Math.random()}`}>
                        <Col xs={12} sm={3}>{u.name || ''}</Col>
                        <Col xs={12} sm={3}>{u.phone || ''}</Col>
                        <Col xs={12} sm={3}>{u.email || ''}</Col>
                        {userIsGroupAdmin(u) ? <Col xs={11} sm={2}><a className="link" onClick={() => props.makeUserNotAdmin(u.id)}>Remove as admin</a></Col>
                            : <Col xs={11} sm={2}><a className="link" onClick={() => props.makeUserAdmin(u.id)}>Make admin</a></Col>}
                        <Col xs={1} sm={1}><a onClick={() => props.deleteUser(u.id)}><img src={trash} alt="delete" style={{width: '14px', height: '18px'}} /></a></Col>
                    </Row>)}

                    <Row className="add-user-group">
                        <Col xs={12}>
                            <a className="link" onClick={() => props.addUserClicked(props.group)}>ADD USER</a>
                        </Col>
                    </Row>
                </Grid>
            </div>
        </Row>

    } else {
        return <Row className="group-row group-row-closed" onClick={() => props.selectGroup(props.group)}>
            <Col xs={10} className="group-name-closed">
                    {props.group.name}
            </Col>
            <Col xs={2} className="group-row-closed-callout">
                <button className="link">
                    <img src={openCallout} alt="open" />
                </button>
            </Col>
        </Row>
    }

}

export default GroupView







// WEBPACK FOOTER //
// ./src/components/admin/groups/GroupView.jsx